import api from '../config/api';

export const getEtapas = () => api.get('/etapas/');
